var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileUploadPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6516 20.0001C25.6516 23.1205 23.122 25.6501 20.0016 25.6501C16.8812 25.6501 14.3516 23.1205 14.3516 20.0001C14.3516 16.8797 16.8812 14.3501 20.0016 14.3501C23.122 14.3501 25.6516 16.8797 25.6516 20.0001Z",
    stroke: "#B00002",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.34 4.75H10.6703L10.8933 4.50629L14.3303 0.75H25.6697L29.1067 4.50629L29.3297 4.75H29.66H36C37.7858 4.75 39.25 6.21421 39.25 8V32C39.25 33.7858 37.7858 35.25 36 35.25H4C2.21421 35.25 0.75 33.7858 0.75 32V8C0.75 6.21421 2.21421 4.75 4 4.75H10.34ZM9.25 20C9.25 25.9342 14.0658 30.75 20 30.75C25.9342 30.75 30.75 25.9342 30.75 20C30.75 14.0658 25.9342 9.25 20 9.25C14.0658 9.25 9.25 14.0658 9.25 20Z",
    stroke: "#B00002",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileUploadPlaceholder);
export default __webpack_public_path__ + "static/media/mobile-upload-placeholder.b3e359bb522c41d3afd40fa178c9b36c.svg";
export { ForwardRef as ReactComponent };